import { ApiModule, NetworkHelper } from '../module/index';
import { Payment, AbstractResponse, Lang } from './../../types';
import { mergeMap } from 'rxjs/operators';
import { UserService } from './user';
import store from './../../store';

const DEFAULT_LANG = Lang.DEFAULT_LANG();

export namespace PaymentService {
  // export const getPaymentFields = (bin: string) => {
  //   return ApiModule.get().workflowApi.get<Payment.Fields>(
  //     '/v1/get_payment_fields/' + bin,
  //   );
  // };

  export const addCard = (card: Object) => {
    const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
    const body = { ...card, locale };
    return ApiModule.get().workflowApi.post<Payment.CardResponse>(
      '/v2/base/paymentcard/add',
      body,
      NetworkHelper.getUTMParams(),
    );
  };

  export const removeCardUseCase = (body: Object) => {
    return removeCard(body).pipe(mergeMap(it => UserService.getUser()));
  };

  export const removeCard = (body: Object) => {
    const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
    const _body = { ...body, locale };
    return ApiModule.get().workflowApi.post<AbstractResponse>(
      '/v1/base/paymentcard/remove',
      _body,
      NetworkHelper.getUTMParams(),
    );
  };

  // export const validateCheckSum = (body: Payment.CheckSumRequest) => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   const _body = { ...body, locale };
  //   return ApiModule.get().workflowApi
  //     .post<Payment.CheckSumResponse>('/v2/base/paymentcard/validate', _body, NetworkHelper.getUTMParams());
  // }

  // export const validateCard = (isTmp: boolean, cvv: string, cardId: string) => {
  //   return isTmp ? validateTemporary(cvv, cardId) : validateSavedButNotVerified(cvv, cardId);
  // }

  // export const validateTemporary = (cvv: string, cardId: string) => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   return ApiModule.get().workflowApi
  //     .post<Payment.ValidationResponse>('/v2/card_temporary/check_summ/' + cardId, { cvv, locale });
  // }

  // export const validateSavedButNotVerified = (cvv: string, cardId: string) => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   return ApiModule.get().workflowApi
  //     .post<Payment.ValidationResponse>('/v2/card_temporary/validate/' + cardId, { cvv, locale });
  // }
}
